import React from 'react';
import PropTypes from 'prop-types';
import SwiperButton from '../../swiperButton/SwiperButton';
import Callout from '../../callout/Callout';

const NewBeginningBlock = ({block, handlePrev, handleNext, active }) => {
    const { bgImage, headline, description } = block;

    return (
        <div className="home--new-beginning-block home-section-block" style={{backgroundImage: `url('${bgImage}')`}}>
            <SwiperButton onClick={handlePrev} inverted />
            <div className="home-section-block-content">
                <Callout
                    headline={headline}
                    description={description}
                    align="center"
                    active={active}
                />
            </div>
            <SwiperButton onClick={handleNext} />
        </div>
    )
};

NewBeginningBlock.propTypes = {
    block: PropTypes.object,
    handlePrev: PropTypes.func,
    handleNext: PropTypes.func,
    active: PropTypes.bool
};

NewBeginningBlock.defaultProps = {
    block: {},
    handlePrev: fn => fn,
    handleNext: fn => fn,
    active: false
};

export default NewBeginningBlock;
